import httpClient from "../httpClient"

export const END_POINT = {
  LOGIN: "/kiban/api/login",
  LOGIN_STATUS: "/kiban/api/login/status",
} as const

const loginApi = {
  login(loginId: string, password: string) {
    type LoginResult =
      | {
          resultCode: "OK" | "AUTHENTICATED"
          errorMessage: null
        }
      | {
          resultCode: "NG" | "ACCOUNT_LOCKED"
          errorMessage: string
        }

    return httpClient.post<LoginResult>(END_POINT.LOGIN, { loginId, password })
  },
  loginStatus() {
    type LoginStatusResult = {
      login: boolean
    }

    return httpClient.get<LoginStatusResult>(END_POINT.LOGIN_STATUS)
  },
} as const

export default loginApi
